import React from 'react'
import PropTypes from 'prop-types'
import ViabilityTable from './ViabilityTable'
import PoorTextField from './PoorTextField'
import '../containers/css/ViabilityTool.css'
import VideoModal from '../components/VideoModal'

class ViabilityTool extends React.Component {

    constructor(props) {
        super(props)
        this.returnType = this.returnType.bind(this)
    }

    returnType(){
        if (this.props.titleSize === 28){
            return 'px'
        }
        else {
            return 'vw'
        }
    }

    render() {
        let totalCost = 0
        let costAmount = 0
        for(let i in this.props.costRows){
            costAmount = parseFloat(this.props.costRows[i].amount)
            if(costAmount > 0){
            totalCost += costAmount
            }
        }
        let totalRevenue = 0
        let revenueAmount = 0
        for(let i in this.props.revenueRows){
            revenueAmount = parseFloat(this.props.revenueRows[i].amount)
            if(revenueAmount > 0){
            totalRevenue += revenueAmount
            }
        }

        return (
            <div>
                <h3 className='costEstimation'>Cost estimation
                    <VideoModal
                        videoTitle='Make a Budget'
                        videoURL='https://www.youtube.com/watch?v=0sEUjdkIP34'
                    />
                </h3>
                {this.props.shouldShow &&
                <div>
                <p>What are the estimated costs of making the idea come true?</p>
                </div>
                }
                <ViabilityTable
                    dataRows={this.props.costRows}
                    showHover={this.props.hoverEffect}
                    shouldShow={this.props.shouldShow}
                    shouldHide={this.props.shouldHide}
                    editMode={this.props.editMode}
                    totalText='TOTAL COSTS'
                    insertButtonText='Add a cost'
                    deleteButtonText='Remove cost(s)'
                    onAddRow={this.props.onAddCostRow}
                    onEditRow={this.props.onEditCostRow}
                    onDeleteRow={this.props.onDeleteCostRow}
                />
                <p className='pull-right'><b style={{color:'red'}}>Total costs</b> {totalCost}</p>

                <h3 className='revenueEstimation'>Revenue estimation</h3>
                {this.props.shouldShow &&
                <div>
                <p>What are the estimated revenues that will come from realising the idea?</p>
                </div>
                }
                <ViabilityTable
                    dataRows={this.props.revenueRows}
                    showHover={this.props.hoverEffect}
                    shouldShow={this.props.shouldShow}
                    shouldHide={this.props.shouldHide}
                    editMode={this.props.editMode}
                    totalText='TOTAL REVENUE'
                    insertButtonText='Add a revenue'
                    deleteButtonText='Remove revenue(s)'
                    onAddRow={this.props.onAddRevenueRow}
                    onEditRow={this.props.onEditRevenueRow}
                    onDeleteRow={this.props.onDeleteRevenueRow}
                />

                <p className='pull-right'><b style={{color:'green'}}>Total revenue</b> {totalRevenue}</p>
                {this.props.shouldShow &&
                <div>
                <h3>Total</h3>

                <p>
                    When looking at the total revenues of <b style={{color:'green'}}>{totalRevenue}</b> compared with the total
                    costs of <b style={{color:'red'}}>{totalCost}</b>. Does the revenues and costs over
                    time justify the realisation of the idea, and also consider
                    your funding needs and what type of funding?
                    Write your considerations below.
                </p>
                <PoorTextField
                    description={this.props.viabilityText}
                    onChange={this.props.onTextChange}
                    label=''
                    placeholder='Text goes here.'
                />
                </div>
                }
            </div>
        )
    }
}
ViabilityTool.propTypes = {
    costRows: PropTypes.array,
    hoverEffect: PropTypes.bool,
    revenueRows: PropTypes.array,
    viabilityText: PropTypes.string,
    editMode: PropTypes.string,
    shouldShow: PropTypes.bool,
    shouldHide: PropTypes.bool,
    titleSize: PropTypes.number,
    onAddCostRow: PropTypes.func.isRequired,
    onEditCostRow: PropTypes.func.isRequired,
    onDeleteCostRow: PropTypes.func.isRequired,
    onAddRevenueRow: PropTypes.func.isRequired,
    onEditRevenueRow: PropTypes.func.isRequired,
    onDeleteRevenueRow: PropTypes.func.isRequired,
    onTextChange: PropTypes.func.isRequired,
}

ViabilityTool.defaultProps = {
    shouldShow: true,
    titleSize: 28,
}

export default ViabilityTool



// WEBPACK FOOTER //
// ./src/components/ViabilityTool.js